if (!customElements.get('m-variant-atc-sync')) {
  /**
   * Keeps the main add-to-cart button in step with the selected variant without
   * replacing it. Enterprise 2.3.0 swaps the button on every variant change,
   * which drops the handler Easify binds to it (tpo_add-to-cart) and with it the
   * upgrade charge. The section leaves the button untagged; this updates it in
   * place, as Enterprise 2.0.1 did.
   */
  class VariantAtcSync extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('.js-product');
      if (!this.product) return;

      this.boundHandleVariantChange = this.handleVariantChange.bind(this);
      this.product.addEventListener('on:variant:change', this.boundHandleVariantChange);
    }

    disconnectedCallback() {
      if (this.product) {
        this.product.removeEventListener('on:variant:change', this.boundHandleVariantChange);
      }
    }

    /**
     * Handles 'on:variant:change' events from the variant picker.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const button = this.product.querySelector('.js-product-form-main [name="add"]');
      if (!button) return;

      const { variant } = evt.detail || {};
      let text;
      let disabled;

      if (!variant) {
        text = button.dataset.preselectionText;
        disabled = button.dataset.preselectionDisabled === 'true';
      } else if (variant.available) {
        text = button.dataset.addToCartText;
        disabled = false;
      } else {
        text = theme.strings.noStock;
        disabled = true;
      }

      button.disabled = disabled;
      if (text && button.textContent.trim() !== text) button.textContent = text;
    }
  }

  customElements.define('m-variant-atc-sync', VariantAtcSync);
}
